import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EjecucionService } from '../../../services/ejecucion.service';
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';

@Component({
  selector: 'app-notas',
  standalone: true,
  imports: [CommonModule, ModalComponent, FormsModule, NgbDatepickerModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './notas.component.html',
  styleUrl: './notas.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class NotasComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Input() id_accion_formativa?: any;
  @Input() nombre_oferta?: any;
  @Input() uc_pre_impreso?: any;
  @Output() vuelve = new EventEmitter<any>();


  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  user: any;

  resultado: any = [];
  cabecera: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  fechaActual: string = '';
  total: number = 0;

  formularioNotas: FormGroup;

  // 1. Declarar las propiedades para los límites de fecha
  fechaSeleccionada!: NgbDateStruct;

  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);
  private fb = inject(FormBuilder);

  constructor(){
    this.srvLogin.user$.subscribe(user => { this.user = user; });
    this.formularioNotas = this.fb.group({
      id_accion_formativa: new FormControl(''),
      id_facilitador: new FormControl(this.user.id_institucional, [Validators.required]),
      participantes: this.fb.array([])
    });
  }

  ngOnInit(): void {
    //console.log('asdasd:   ', this.user.id_institucional)
    //console.log('weeeee:   ', this.id_accion_formativa)
    const fecha = new Date();
    this.fechaActual = formatDate(fecha, 'dd-MM-yyyy', 'en-US'); // Formato: día/mes/año
  }

  get participantes() {
    return this.formularioNotas.get("participantes") as FormArray
  }

  notas(id: number) {
    return (this.formularioNotas.get('participantes') as FormArray)?.at(id)?.get('notas') as FormArray;
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.notas(this.id_accion_formativa).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = rs.data;
        if(this.resultado.length == 0){
          this.vuelve.emit({value: false, validador: false, warning: 1});
        }
        else{
          this.cabecera = this.resultado[0];

          this.resultado = rs.data.map((item: any) => {
              // 1. Usa reduce() para sumar los valores del array 'evaluacion'
              const sumaNotas = item.evaluacion.reduce((acumulador: number, evaluacionItem: any) => {
                // Obtener el valor de 'nota', convirtiendo 'null' a 0
                let notaValor: number;
                if (evaluacionItem.nota === null || evaluacionItem.nota === undefined) {
                  notaValor = 0;
                } else {
                  // Asegúrate de parsear el valor a un número si viene como string
                  notaValor = parseFloat(evaluacionItem.nota);
                  // Manejar si el parseo falla y se convierte en NaN
                  if (isNaN(notaValor)) {
                      notaValor = 0;
                  }
                }
                // Sumar el valor de la nota al acumulador
                return acumulador + notaValor;
              }, 0); // El '0' es el valor inicial del acumulador
              // 2. Devolver el nuevo objeto con la suma asignada a 'total_nota'
              return {...item, total_nota: sumaNotas};
          });

          //console.log('Datos cantidad:', this.resultado.length);
          //console.log('Datos inicializados:', this.resultado);
          //console.log('Datos otros:', this.cabecera.evaluacion);

          for (let i = 0; i < this.resultado.length; i++) {
            const v = this.resultado[i];

            // Creamos un FormGroup para cada 'key' y le asignamos el FormArray de UCs
            this.participantes.push(
              this.fb.group({
                id_participante: [v.id_participante], // Almacenamos la 'key' por si la necesitas
                id_evaluacion_participante: [v.id_evaluacion_participante],
                notas: this.fb.array([])
              })
            );

            const notasArr = this.notas(i)
            v.evaluacion.forEach((ev:any) => {
              notasArr.push(
                this.fb.group({
                  id_evaluacion: [ev.id_evaluacion == null ? '' : ev.id_evaluacion],
                  fecha: [ev.fecha == null ? '' : ev.fecha],
                  nota: [ev.nota == null ? '' : ev.nota, Validators.required]
                })
              );
            });
          }



          this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
        }
        //this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }


  // Método para filtrar la tabla
  buscarAccionFormativa() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const nombreApremdiz = item.nombres_apellidos ? this.quitarAcentos(item.nombres_apellidos.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        nombreApremdiz.includes(term)
      );
    });
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }


  // La función ahora recibe el índice (i) y el nuevo valor (nuevoValorStr) como string
  calcula(indexA: number, indexB:number, nuevoValorStr: any){
    let totalSuma = 0;
    const nuevoValor = parseFloat(nuevoValorStr.value) || 0;
    // 3. Lógica de Validación (si el total excede 100)
    if (nuevoValor > this.resultado[indexA].evaluacion[indexB].porcentaje_evaluacion) {
      // Calculamos cuánto excedimos los 100 puntos
      const exceso = nuevoValor - this.resultado[indexA].evaluacion[indexB].porcentaje_evaluacion;
      // Revertimos el porcentaje del elemento modificado al valor máximo permitido
      const valorCorregido = nuevoValor - exceso;
      this.resultado[indexA].evaluacion[indexB].nota = valorCorregido > 0 ? valorCorregido : 0;
      this.notas(indexA).at(indexB).get('nota')?.setValue(valorCorregido > 0 ? valorCorregido : 0);
      nuevoValorStr.value = valorCorregido
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = "warning";
      this.letra_color = "dark";
      this.mensaje = `¡El valor máximo total es (${this.resultado[indexA].evaluacion[indexB].porcentaje_evaluacion}%)!
                      El porcentaje del Plan de Evaluación no puede superar ese límite.`;
      this.mdl.alerta();
    } else {
      // 4. Si el total es válido, simplemente actualizamos la variable total
      this.resultado[indexA].evaluacion[indexB].nota = nuevoValor;
    }
    // Calcular el total actual
    for (const item of this.resultado[indexA].evaluacion) {
      const valorPorcentaje = parseFloat(item.nota || 0);
      if (!isNaN(valorPorcentaje) && valorPorcentaje >= 0) { totalSuma += valorPorcentaje; }
    }
    this.resultado[indexA].total_nota = totalSuma;
  }

  confirmacion(){
     Object.assign(this.formularioNotas.value, {
      'id_accion_formativa': this.id_accion_formativa
    });
    let valida: boolean = false;
    for (let i = 0; i < ((this.formularioNotas.value).participantes).length; i++) {
      const element = this.notas(i).value;
      valida = this.notas(i).valid ? true : false;
      console.log('sadasd:    ',valida)
      if(!valida) break;
    }

    if(valida){
      this.mdl.confirma();
    }else{
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = "warning";
      this.letra_color = "dark";
      this.mensaje = `¡Por favor complete todos los campos de las notas!`;
      this.mdl.alerta();
    }


  }

  guardar_todo(){
    console.log('todos: ', this.formularioNotas.value)
    this.mdl.cargando();
    this.servicios.cargaNotas(this.formularioNotas.value).subscribe({
      next: (rs) => {
        console.log('prueba:  ',rs)
        this.mdl.cerrar();
        this.vuelve.emit({value: false, validador: true, warning: 0});
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  volver(){
    this.vuelve.emit({value: false, validador: false, warning: 0});
  }

}
